export default '1.7.6';



// WEBPACK FOOTER //
// ./version.js